import { ref, reactive } from 'vue';
import "ant-design-vue/es/message/style/css";
import _message from "ant-design-vue/es/message";
import "core-js/modules/es.array.push.js";
import dayjs from 'dayjs';
import { Post, Get } from '@/api/Api';
import { ls } from 'vue-lsp';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import { FieldBinaryOutlined } from '@ant-design/icons-vue';
export default {
  name: 'Index',
  components: {},
  setup(props, context) {
    const RefForm = ref();
    const IsShow = ref(false);
    const IsDisabled = ref(false);
    const DMConfig = reactive({
      FId: 0,
      Title: '',
      Width: '0',
      Height: '0',
      loading: false,
      ModelClass: '',
      Model: {},
      TermsOfSaleList: [],
      SettleList: [],
      DMForm: {
        form: {
          labelCol: {
            style: {
              width: '160px'
            }
          }
        }
      },
      Columns: [{
        title: "Item No.",
        dataIndex: "itemNo",
        /* customRender:(record) => {
        	return <a onclick ={() => {DMPriceref.value.Open(record.record.fId,600,0)}}> {record.record.fCustNumber} </a>
        }, */
        width: 80,
        align: 'center'
      }, {
        title: "Customer Pro Code",
        dataIndex: "customerProCode",
        rules: []
      }, {
        title: "Product Number",
        dataIndex: "productNumber",
        rules: [{
          required: true,
          message: ''
        }]
      }, {
        title: "K3 Product Number",
        dataIndex: "itemNumber",
        rules: []
      }, {
        title: "Description of Goods",
        dataIndex: "descriptionOfGoods",
        rules: [{
          required: true,
          message: ''
        }]
      }, {
        title: "Color",
        dataIndex: "color",
        width: 120
      }, {
        title: "Electric",
        dataIndex: "electric",
        width: 120
      }, {
        title: "Qty",
        dataIndex: "qty",
        width: 80,
        align: 'right',
        rules: [{
          required: true,
          message: ''
        }]
      }, {
        title: "Unit Price(USD)",
        dataIndex: "unitPrice",
        width: 120,
        align: 'right',
        rules: [{
          required: true,
          message: ''
        }]
      }, {
        title: "Total Amt(USD)",
        dataIndex: "totalAmt",
        width: 120,
        align: 'right'
      }, {
        title: "operate",
        dataIndex: "operation",
        width: 60,
        align: 'center'
      }]
    });
    const SubmitForm = e => {
      RefForm.value.validate().then(() => {
        console.log('values11', DMConfig.Model);
        if (DMConfig.Model.shipmentDate == '') {
          DMConfig.Model.shipmentDate = null;
        }
        DMConfig.loading = true;
        Post("DM/SaveOrders", DMConfig.Model).then(res => {
          if (res.succeeded) {
            _message.success('保存成功');
            context.emit('ok');
            IsShow.value = false;
          } else {
            _message.error('保存失败：' + res.errors);
            DMConfig.loading = false;
          }
        }).catch(err => {
          _message.error(err.errors);
          DMConfig.loading = false;
        });
      }).catch(error => {
        console.log(error);
        error.errorFields.forEach((key, i) => {
          console.log(key);
          const firstFiled = key.name[0];
          _message.error(key.errors[0]);
        });
        //message.error(error.message);
      });
    };

    const GetTermsOfSaleList = () => {
      Get("/DM/GetTermsOfSaleList", {}).then(res => {
        DMConfig.TermsOfSaleList = res.data;
      });
    };
    const GetSettleList = () => {
      Get("/DM/GetSettleList", {}).then(res => {
        DMConfig.SettleList = res.data;
      });
    };
    const ResetForm = (form, DataSource) => {
      console.log('DataSource');
    };
    const Open = (fId, width, height) => {
      IsShow.value = true;
      DMConfig.loading = true;
      DMConfig.FId = fId;
      DMConfig.Title = (fId == 0 ? '新增' : '修改') + '订单';
      DMConfig.Width = width == 0 ? "100%" : width;
      DMConfig.ModelClass = width == 0 ? "full-modal" : "";
      DMConfig.Height = height == 0 ? "100%" : height;
      GetTermsOfSaleList();
      GetSettleList();
      if (fId > 0) {
        Get("/DM/GetOrders", {
          id: fId
        }).then(res => {
          DMConfig.Model = res.data;
          IsDisabled.value = !(DMConfig.Model.fState == 0 || DMConfig.Model.fState == 3);
          if (DMConfig.Model.shipmentDate == null || DMConfig.Model.shipmentDate == '') {
            DMConfig.Model.shipmentDate = '';
          } else {
            DMConfig.Model.shipmentDate = ref(dayjs(DMConfig.Model.shipmentDate, 'YYYY-MM-DD'));
          }
          DMConfig.loading = false;
        });
      } else {
        DMConfig.Model = {};
        DMConfig.loading = false;
      }
    };
    const OnTotalAmt = record => {
      record.totalAmt = record.qty * 1000 * (record.unitPrice * 1000) / 1000000;
      DMConfig.Model.total = 0;
      DMConfig.Model['items'].forEach(item => {
        DMConfig.Model.total += item.totalAmt;
      });
      DMConfig.Model.total += DMConfig.Model.processingFee;
      DMConfig.Model.total -= DMConfig.Model.discount;
      DMConfig.Model.total = parseFloat(DMConfig.Model.total.toFixed(2));
    };
    const OnChangeDiscount = () => {
      DMConfig.Model.total = 0;
      DMConfig.Model['items'].forEach(item => {
        DMConfig.Model.total += item.totalAmt;
      });
      DMConfig.Model.total += DMConfig.Model.processingFee;
      DMConfig.Model.total -= DMConfig.Model.discount;
      DMConfig.Model.total = parseFloat(DMConfig.Model.total.toFixed(2));
    };
    const OnSelectProductNumber = record => {
      console.log(record);
      ///dm/GetPIPrice
      Get("/DM/GetPIPrice", {
        CustId: DMConfig.Model.fCustId,
        productNumber: record.productNumber
      }).then(res => {
        if (res.data) {
          record.customerProCode = res.data.fbursonProCode;
          record.itemNumber = res.data.fNumber;
          record.descriptionOfGoods = res.data.fDescription;
          record.color = res.data.fColor;
          record.electric = res.data.fElectric;
          record.unitPrice = res.data.fPrice;
          OnTotalAmt(record);
        }
      });
    };
    const delRow = record => {
      const newData = DMConfig.Model['items'].filter(item => item !== record);
      DMConfig.Model['items'] = newData;
    };
    const addRow = () => {
      DMConfig.Model['items'].push({
        itemNo: DMConfig.Model['items'].length + 1
      });
    };
    return {
      IsShow,
      IsDisabled,
      Open,
      delRow,
      addRow,
      RefForm,
      DMConfig,
      SubmitForm,
      ResetForm,
      OnTotalAmt,
      OnChangeDiscount,
      OnSelectProductNumber,
      GetTermsOfSaleList,
      GetSettleList
    };
  },
  created() {
    console.log('created');
  },
  mounted() {},
  methods: {}
};